export * from './IconCommentFilled';
